import { Route, Switch, useRouteMatch } from 'react-router-dom';
import OrderCanceledContainer from './order-canceled/OrderCanceledContainer';
import OrderConfirmedContainer from './order-confirmed/OrderConfirmedContainer';

function OrderRouter() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}/confirmed`} component={OrderConfirmedContainer} />
      <Route path={`${path}/canceled`} component={OrderCanceledContainer} />
      <Route>
        <h1>Uh oh...</h1>
        <h3>Something went wrong with this order. Please try again later.</h3>
      </Route>
    </Switch>
  );
}

export default OrderRouter;
